import { Nullable } from '@internal-libraries/kheops-ui-lib'
import { HospitalRoomData } from '../Types/HospitalRoomData'
import { HospitalRoomDto } from '../Types/HospitalRoomDto'

export default class ClvrHospitalRoom {
    public id: Nullable<number> = null
    public name = ''

    public constructor(data?: HospitalRoomData) {
        if (data) {
            Object.assign(this, data)
        }
    }

    public toDto(): HospitalRoomDto {
        return {
            id: this.id,
            name: this.name,
        }
    }
}
